import { getLocale } from "../runtime";

const sv_handoverparcel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `När ditt paket skickas får du ett mejl med en spårningslänk och mer information.`
};

const handoverparcel = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_handoverparcel(inputs)
	return "handOverParcel";
};

export { handoverparcel as "handOverParcel" };